import Vue from 'vue'
import Router from 'vue-router'
import CreateDepartment from './views/Create-Department'
import CreatePublicFolder from './views/Create-Public-Folder'
import GroupFolderRequest from './views/Group-Folder-Request'
import UsageQuota from './views/Usage-Quota'
import MyPlan from './views/My-Plan'
import cookies from '@/services/cookies'
import AuthenticationService from "@/services/AuthenticationService";

Vue.use(Router)

const guard = function (to, from, next) {
  if (cookies.getCookie('token') == null || cookies.getCookie('token') == undefined || cookies.getCookie('token') == '') {
    window.location.href = '/login'
  } else {
    AuthenticationService.authuser({ token: cookies.getCookie('token') }).then((res) => {
      if (res.data.result) {
        next()
      } else {
        cookies.removeCookie('token')
        window.location.href = '/login'
      }
    }).catch((err) => {
      cookies.removeCookie('token')
      window.location.href = '/login'
    })
  }
  // next()
};

const guard2 = function (to, from, next) {
  if (cookies.getCookie('temp_token') == null || cookies.getCookie('temp_token') == undefined || cookies.getCookie('temp_token') == '') {
    window.location.href = '/login'
  } else {
    AuthenticationService.authuser({ token: cookies.getCookie('temp_token') }).then((res) => {
      if (res.data.result) {
        next()
      } else {
        cookies.removeCookie('temp_token')
        window.location.href = '/login'
      }
    }).catch((err) => {
      cookies.removeCookie('temp_token')
      window.location.href = '/login'
    })
  }
  // next()
};



let router = {
  mode: 'history',
  routes: [
    {
      path: '/api/login',
      name: 'api_login',
      meta: { title: 'Auth' },
      component: () => import(/* webpackChunkName: "api_login" */ './views/Api-Login.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: { title: 'Fexspace - Login' },
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot_password',
      meta: { title: 'Fexspace - Forgot Password' },
      component: () => import(/* webpackChunkName: "forgot_password" */ './views/Forgot-Password.vue')
    },
    {
      path: '/reset-password/:link',
      name: 'reset_password',
      meta: { title: 'Fexspace - Password Reset Link' },
      component: () => import(/* webpackChunkName: "reset_password" */ './views/Reset-Password.vue')
    },
    {
      path: '/view-doc/:file',
      name: 'view_doc',
      meta: { title: 'Fexspace - View Document' },
      component: () => import(/* webpackChunkName: "view_doc_file" */ './views/View-Doc-File.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/edit-doc/:file',
      name: 'edit_doc',
      meta: { title: 'Fexspace - Edit Document' },
      component: () => import(/* webpackChunkName: "edit_doc_file" */ './views/Edit-Doc-File.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/public-view-doc/:file',
      name: 'public_view_doc',
      meta: { title: 'Fexspace - View Document' },
      component: () => import(/* webpackChunkName: "public_view_doc_file" */ './views/Public-View-Doc-File.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/public-edit-doc/:file',
      name: 'public_edit_doc',
      meta: { title: 'Fexspace - Edit Document' },
      component: () => import(/* webpackChunkName: "public_edit_doc_file" */ './views/Public-Edit-Doc-File.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/file/link/:id',
      name: 'view_file',
      meta: { title: 'Fexspace - View File' },
      component: () => import(/* webpackChunkName: "view_shared_file" */ './views/View-Shared-File.vue'),
    },
    {
      path: '/verify-email-link/:link',
      name: 'verify_email_link',
      meta: { title: 'Fexspace - Verify Email Link' },
      component: () => import('./views/Verify-Email-Link.vue')
    },
    {
      path: '/verify-email-note',
      name: 'verify_email_note',
      meta: { title: 'Fexspace - Verify Email Note' },
      component: () => import('./views/Verify-Email-Note.vue')
    },
    {
      path: '/appsumo',
      name: 'appsumo_code',
      meta: { title: 'Fexspace - Create Account using AppSumo Code' },
      component: () => import('./views/Use-AppSumo-Code.vue')
    },
    {
      path: '/continue-login',
      name: 'continue_login',
      meta: { title: 'Fexspace - Login' },
      component: () => import('./views/Continue-Login.vue')
    },
    {
      path: '/continue-setup',
      name: 'continue_setup',
      meta: { title: 'Fexspace - Continue setup' },
      component: () => import('./views/Continue-Setup.vue')
    },
    {
      path: '/doc/link/:id',
      name: 'view_doc_link',
      meta: { title: 'Fexspace - View File' },
      component: () => import(/* webpackChunkName: "view_shared_doc" */ './views/View-Shared-Doc.vue')
    },
    {
      path: '/create-public-folder',
      name: 'create_public_folder',
      meta: { title: 'Fexspace - Create Public Folder' },
      component: CreatePublicFolder,
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/create-page',
      name: 'create_page',
      meta: { title: 'Fexspace - Create a page for your company ' },
      component: () => import(/* webpackChunkName: "create_page" */ './views/Create-Page.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/group-folder-request',
      name: 'group_folder_request',
      meta: { title: 'Fexspace - Group Folder Request' },
      component: GroupFolderRequest,
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/reset-link/:token',
      name: 'reset_link',
      meta: { title: 'Fexspace - Reset link' },
      component: () => import(/* webpackChunkName: "reset_link" */ './views/Reset-Link.vue')
    },
    {
      path: '/pass-set/:token',
      name: 'pass-set',
      meta: { title: 'Fexspace - Reset Password' },
      component: () => import(/* webpackChunkName: "reset_password_link" */ './views/Reset-Password-Link.vue')
    },
    {
      path: '/usage-quota',
      name: 'usage_quota',
      meta: { title: 'Fexspace - Usage Quota' },
      component: UsageQuota,
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/my-plan',
      name: 'my_plan',
      meta: { title: 'Fexspace - My Plan' },
      component: MyPlan,
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/update-profile',
      name: 'update_profile',
      meta: { title: 'Fexspace - Update Profile' },
      component: () => import(/* webpackChunkName: "update_profile" */ './views/Update-Profile.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/all-users',
      name: 'users',
      meta: { title: 'Fexspace - All Users' },
      component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/payments-billing',
      name: 'billing',
      meta: { title: 'Fexspace - Payments & Billing' },
      component: () => import(/* webpackChunkName: "payments_billing" */ './views/Payments-Billing.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/create-account',
      name: 'create_account',
      meta: { title: 'Fexspace - Create Account' },
      component: () => import(/* webpackChunkName: "create_account" */ './views/Create-Account.vue')
    },
    {
      path: '/create-department',
      name: 'create_department',
      meta: { title: 'Fexspace - Create Department' },
      component: CreateDepartment,
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/authenticate',
      name: 'authenticate',
      meta: { title: 'Fexspace - Authenticate' },
      component: () => import(/* webpackChunkName: "authenticate" */ './views/Authenticate.vue'),
      beforeEnter: (to, from, next) => {
        guard2(to, from, next)
      }
    },
    {
      path: '/setup-account',
      name: 'setup_account',
      meta: { title: 'Fexspace - Set Up Account' },
      component: () => import(/* webpackChunkName: "setup_account" */ './views/Setup-Account.vue'),
      beforeEnter: (to, from, next) => {
        guard2(to, from, next)
      }
    },
    {
      path: '/:id?',
      name: 'home',
      // beforeEnter: (to, from, next) => {
      //   if (getCookie(name) == null || getCookie(name) == undefined) {
      //     next('/login')
      //   }
      //   next()
      //   // ...
      // },
      meta: {
        title: 'Fexspace - Drive'
      },
      component: () => import('./views/Home.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/drive',
      name: 'drive',
      meta: {
        title: 'Fexspace - Drive'
      },
      component: () => import(/* webpackChunkName: "drive" */ './views/Drive.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/shared-with-me',
      name: 'shared_with_me',
      meta: { title: 'Fexspace - Drive' },
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/print-text/:file',
      name: 'printtext',
      meta: { title: 'Fexspace' },
      component: () => import(/* webpackChunkName: "printtext" */ './views/Print-Text.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/print-image/:file',
      name: 'printimage',
      meta: { title: 'Fexspace' },
      component: () => import(/* webpackChunkName: "printimage" */ './views/Print-Image.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/user/files/:id',
      name: 'userfile',
      meta: { title: 'Fexspace' },
      component: () => import(/* webpackChunkName: "userfiles" */ './views/User-Files.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/group-view-doc/:file',
      name: 'group_view_doc',
      meta: { title: 'Fexspace - View Document' },
      component: () => import(/* webpackChunkName: "group_view_file" */ './views/Group-View-File.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/shared-view-doc/:file',
      name: 'shared_view_doc',
      meta: { title: 'Fexspace - View Document' },
      component: () => import(/* webpackChunkName: "shared_view_file" */ './views/Shared-View-File.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/group-edit-doc/:file',
      name: 'group_edit_doc',
      meta: { title: 'Fexspace - Edit Document' },
      component: () => import(/* webpackChunkName: "group_edit_file" */ './views/Group-Edit-File.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/shared-edit-doc/:file',
      name: 'shared_edit_doc',
      meta: { title: 'Fexspace - Edit Document' },
      component: () => import(/* webpackChunkName: "shared_edit_file" */ './views/Shared-Edit-File.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '/view-user-doc/:file',
      name: 'view_user_doc',
      meta: { title: 'Fexspace - View Document' },
      component: () => import(/* webpackChunkName: "view_user_doc" */ './views/View-User-Doc.vue'),
      beforeEnter: (to, from, next) => {
        guard(to, from, next)
      }
    },
    {
      path: '*',
      name: 'page_not_found',
      meta: { title: 'Fexspace - Page Not Found' },
      component: () => import(/* webpackChunkName: "page_not_found" */ './views/Page-Not-Found.vue')
    }
  ]
}

let rt = new Router(router)

export default rt

function getCookie(name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}
